import React from 'react';
import { TextField, Tooltip, Typography, Box, IconButton, InputAdornment } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import InfoIcon from '@mui/icons-material/Info';

export const SecretInput = ({ secret, value, onChange }) => (
    <Box mb={2}>
        <TextField
            name={secret.name}
            key={secret.name}
            label={
                <Box display="flex" alignItems="center">
                    <LockIcon color="primary" />
                    <Box ml={1}>{`${secret.description}${secret?.optional ? ' (Optional)' : ''}`}</Box>
                </Box>
            }
            type="password"
            value={value}
            onChange={onChange}
            margin="normal"
            rows={secret?.rows ? secret?.rows : undefined}
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Tooltip title="Your secret is encrypted with your private AES key before leaving the browser" arrow>
                            <IconButton edge="end">
                                <InfoIcon color="action" />
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                ),
            }}
        />
    </Box>
);
